module.exports = __webpack_public_path__ + "static/media/random_category.5cf6e838.jpg";